import Dexie from 'dexie'
import axios from 'axios'
import localforage from 'localforage'

export const urlBackend = 'https://calculadora-zeposia-api-UAT.proyectocelvision.net/api/login/'
export const urlCTM = 'https://ctm-spain.proyectocelvision.net'

export const auth = {
    compruebaAccesos: async function () {
        let credencialesFlag = false
        await Dexie.exists('credenciales').then(async function (exists) {
            if (exists) {
                const dbCredenciales = new Dexie('credenciales')
                await dbCredenciales.version(1).stores(
                    { credenciales: `id,nombre,mail,telefono,idToken,rol` }
                )
                const result = await dbCredenciales.credenciales.where('id').equals(1).toArray()
                if (result.length) {
                    credencialesFlag = true
                } else {
                    credencialesFlag = false
                }
            } else {
                credencialesFlag = false
            }
        })
        return credencialesFlag
    },
    destroyAccessos: async function () {
        await Dexie.delete('credenciales')
        return true
    },
    accesoAdm: async function () {
        let credencialesADMFlag = false
        await Dexie.exists('credenciales').then(async function (exists) {
            if (exists) {
                const dbCredenciales = new Dexie('credenciales')
                await dbCredenciales.version(1).stores(
                    { credenciales: `id,nombre,mail,telefono,idToken,rol` }
                )
                const result = await dbCredenciales.credenciales.where('id').equals(1).toArray()
                if (result.length) {
                    if (parseInt(result[0].rol) === parseInt(20) || parseInt(result[0].rol) === parseInt(10)) {
                        credencialesADMFlag = true
                    } else {
                        credencialesADMFlag = false
                    }
                } else {
                    credencialesADMFlag = false
                }
            } else {
                credencialesADMFlag = false
            }
        })
        return credencialesADMFlag
    }
}

export const valoresCostes = {
    getValores: async function () {
        return await axios.post(urlBackend, {
            action: 'getdatos'
        })
    }
}

export const guardarDatos = {
    guardarDatos: async function (valores) {
        return await axios.post(urlBackend, {
            action: 'guardardatos',
            data: valores
        })
    }
}

export const comp10mgPorPeso = [
    {
        "min": 40,
        "max": 49,
        "semana 1": 4,
        "semana 2": 4
    },
    {
        "min": 50,
        "max": 59,
        "semana 1": 5,
        "semana 2": 5
    },
    {
        "min": 60,
        "max": 69,
        "semana 1": 6,
        "semana 2": 6
    },
    {
        "min": 70,
        "max": 79,
        "semana 1": 7,
        "semana 2": 7
    },
    {
        "min": 80,
        "max": 89,
        "semana 1": 8,
        "semana 2": 7
    },
    {
        "min": 90,
        "max": 99,
        "semana 1": 9,
        "semana 2": 8
    },
    {
        "min": 100,
        "max": 149,
        "semana 1": 10,
        "semana 2": 9
    },
    {
        "min": 150,
        "max": 9999,
        "semana 1": 10,
        "semana 2": 10
    }
];

export const costesFarmacos_default = [
    {
        "id": 1,
        "Principio activo": "Betaferon",
        "Presentación": "IFNβ-1b Betaferon® 250 µg 15 viales",
        "mg": 0.25,
        "Unidades": 15,
        "PVL": 865.00,
        "PF": 807.33,
        "Pus": '',
        "RDL": 0.0,
        "Administración": "SC",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 1,
            "Dias": 2,
            "Texto": "dos días"
        }
    },
    {
        "id": 2,
        "Principio activo": "Avonex",
        "Presentación": "IFNβ-1a Avonex® 30 µg 4 jeringas precargadas",
        "mg": 0.03,
        "Unidades": 4,
        "PVL": 835.82,
        "PF": 775.65,
        "Pus": '',
        "RDL": 0.0,
        "Administración": "IM",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 1,
            "Dias": 7,
            "Texto": "semanal"
        }
    },
    {
        "id": 4,
        "Principio activo": "Rebif",
        "Presentación": "IFNβ-1a Rebif® 44 µg 4 cartuchos",
        "mg": 0.044,
        "Unidades": 4,
        "PVL": 1129.55,
        "PF": 1129.55,
        "Pus": '',
        "RDL": 0.0,
        "Administración": "SC",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 3,
            "Dias": 7,
            "Texto": "semanal"
        }
    },
    {
        "id": 3,
        "Principio activo": "Rebif",
        "Presentación": "IFNβ-1a Rebif® 22 µg 4 cartuchos",
        "mg": 0.022,
        "Unidades": 12,
        "PVL": 564.78,
        "PF": 564.78,
        "Pus": '',
        "RDL": 0.0,
        "Administración": "SC",
        "Presentación reducida": "IFNβ-1a Rebif® 22-44 µg 4 cartuchos",
        "Dias de carga": 28,
        "Unidades carga": 1,
        "Unidades posteriores": 12,
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 3,
            "Dias": 12,
            "Texto": "x semanas 1-4"
        }
    },
    {
        "id": 5,
        "Principio activo": "Plegridy",
        "Presentación": "Peg IFNβ-1a Plegridy® 125 µg 2 plumas",
        "mg": 0.125,
        "Unidades": 2,
        "PVL": 844.17,
        "PF": 844.17,
        "Pus": '',
        "RDL": 7.5,
        "Administración": "SC",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 1,
            "Dias": 14,
            "Texto": "dos semanas"
        }
    },
    {
        "id": 6,
        "Principio activo": "Plegridy",
        "Presentación": "Peg IFNβ-1a Plegridy® 63+94 µg 2 plumas",
        "mg": 0.157,
        "Unidades": 2,
        "PVL": 530.14,
        "PF": 530.14,
        "Pus": '',
        "RDL": 7.5,
        "Administración": "SC",
        "Presentación reducida": "Peg IFNβ-1a Plegridy® SC",
        "Dias de carga": 14,
        "Unidades carga": 1,
        "Unidades posteriores": 12,
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 2,
            "Dias": 2,
            "Texto": "semanas 1-2"
        }
    },
    {
        "id": 21,
        "Principio activo": "Plegridy",
        "Presentación": "Peg IFNβ-1a Plegridy® 125 µg 2 plumas IM",
        "mg": 0.125,
        "Unidades": 2,
        "PVL": 844.17,
        "PF": 820.28,
        "Pus": '',
        "RDL": 7.5,
        "Administración": "IM",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 1,
            "Dias": 14,
            "Texto": "dos semanas"
        }
    },
    {
        "id": 22,
        "Principio activo": "Plegridy",
        "Presentación": "Peg IFNβ-1a Plegridy® 63+94 µg 2 plumas IM ",
        "mg": 0.157,
        "Unidades": 2,
        "PVL": 530.14,
        "PF": 530.14,
        "Pus": '',
        "RDL": 7.5,
        "Administración": "IM",
        "Presentación reducida": "Peg IFNβ-1a Plegridy® IM",
        "Dias de carga": 14,
        "Unidades carga": 1,
        "Unidades posteriores": 12,
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 2,
            "Dias": 2,
            "Texto": "semanas 1-2"
        }
    },
    {
        "id": 7,
        "Principio activo": "Copaxone",
        "Presentación": "Acetato de glatirámero Copaxone® 20 mg 28 jeringas",
        "mg": 20,
        "Unidades": 28,
        "PVL": 625.00,
        "PF": 581.95,
        "Pus": '',
        "RDL": 0.0,
        "Administración": "SC",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 1,
            "Dias": 1,
            "Texto": "diario"
        }
    },
    {
        "id": 18,
        "Principio activo": "Copaxone",
        "Presentación": "Acetato de glatirámero Copaxone® 40 mg 12 jeringas",
        "mg": 40,
        "Unidades": 12,
        "PVL": 781.25,
        "PF": 535.71,
        "Pus": '',
        "RDL": 0.0,
        "Administración": "SC",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 3,
            "Dias": 7,
            "Texto": "semana"
        }
    },
    {
        "id": 8,
        "Principio activo": "Tecfidera",
        "Presentación": "Dimetilfumarato Tecfidera® 240 mg 56 capsulas",
        "mg": 240,
        "Unidades": 56,
        "PVL": 1074.40,
        "PF": 800.32,
        "Pus": '',
        "RDL": 7.5,
        "Administración": "Oral",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 2,
            "Dias": 1,
            "Texto": "diaria"
        }
    },
    {
        "id": 9,
        "Principio activo": "Tecfidera",
        "Presentación": "Dimetilfumarato Tecfidera® 120 mg 14 capsulas",
        "mg": 120,
        "Unidades": 14,
        "PVL": 134.30,
        "PF": 134.30,
        "Pus": '',
        "RDL": 7.5,
        "Presentación reducida": "Dimetilfumarato Tecfidera®",
        "Dias de carga": 7,
        "Unidades carga": 1,
        "Unidades posteriores": 12,
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 2,
            "Dias": 7,
            "Texto": "días 1-7"
        }
    },
    {
        "id": 10,
        "Principio activo": "Aubagio",
        "Presentación": "Terifluonomida Aubagio® 14 mg 28 comprimidos",
        "mg": 14,
        "Unidades": 28,
        "PVL": 1053.18,
        "PF": 782.14,
        "Pus": '',
        "RDL": 7.5,
        "Administración": "Oral",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 1,
            "Dias": 1,
            "Texto": "diaria"
        }
    },
    {
        "id": 11,
        "Principio activo": "Mavenclad",
        "Presentación": "Cladribina Mavenclad® 10 mg 6 comprimidos",
        "mg": 10,
        "Unidades": 6,
        "PVL": 13620.00,
        "PF": 13620.00,
        "Pus": '',
        "RDL": 7.5,
        "Administración": "Oral",
        "EsAnual": true,
        "FrecuenciaUni": {
            "Unidades": [6, 6],
            "Dias": 182.5,
            "Texto": "2 semanas al año"
        }
    },
    {
        "id": 19,
        "Principio activo": "Mavenclad",
        "Presentación": "Cladribina Mavenclad® 10 mg 1 comprimidos",
        "mg": 10,
        "Unidades": 1,
        "PVL": 2270.00,
        "PF": 1916.00,
        "Pus": '',
        "RDL": 7.5,
        "Administración": "Oral",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 1,
            "Dias": 365,
            "Texto": "1 vez al año"
        }
    },
    {
        "id": 12,
        "Principio activo": "Gilenya",
        "Presentación": "Fingolimod Gilenya® 0,5 mg 28 cápsulas duras",
        "mg": 0.5,
        "Unidades": 28,
        "PVL": 1520.00,
        "PF": 1415.31,
        "Pus": '',
        "RDL": 7.5,
        "Administración": "Oral",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 1,
            "Dias": 1,
            "Texto": "diaria"
        }
    },
    {
        "id": 13,
        "Principio activo": "Tysabri",
        "Presentación": "Natalizumab Tysabri® 300 mg 1 vial",
        "mg": 300,
        "Unidades": 1,
        "PVL": 1638.85,
        "PF": 1638.85,
        "Pus": '',
        "RDL": 15.0,
        "Administración": "IV",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 1,
            "Dias": 28,
            "Texto": "4 semanas"
        }
    },
    {
        "id": 20,
        "Principio activo": "Tysabri",
        "Presentación": "Natalizumab Tysabri® 150 mg 2 jerigas precargadas sc",
        "mg": 150,
        "Unidades": 2,
        "PVL": 16363.85,
        "PF": 1353.72,
        "Pus": '',
        "RDL": 7.5,
        "Administración": "SC",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 2,
            "Dias": 28,
            "Texto": "4 semanas"
        }
    },
    {
        "id": 14,
        "Principio activo": "Ocrevus",
        "Presentación": "Ocrelizumab Ocrevus® 300 mg 1 vial",
        "mg": 300,
        "Unidades": 1,
        "PVL": 5750.00,
        "PF": 5750.00,
        "Pus": '',
        "RDL": 7.5,
        "Administración": "IV",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 2,
            "Dias": 182.5,
            "Texto": "semestral"
        }
    },
    {
        "id": 15,
        "Principio activo": "Lemtrada",
        "Presentación": "Alemtuzumab Lemtrada® 12 mg 1 vial",
        "mg": 12,
        "Unidades": 1,
        "PVL": 7500.00,
        "PF": 4350.00,
        "Pus": '',
        "RDL": 7.5,
        "Administración": "IV",
        "EsAnual": true,
        "FrecuenciaUni": {
            "Unidades": [5, 3],
            "Dias": 365,
            "Texto": "anual"
        }
    },
    {
        "id": 16,
        "Principio activo": "Zeposia",
        "Presentación": "Ozanimod Zeposia® 0,92 mg 28 cápsulas duras",
        "mg": 0.92,
        "Unidades": 28,
        "PVL": 862.50,
        "PF": 762.98,
        "Pus": '',
        "RDL": 7.5,
        "Administración": "Oral",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 1,
            "Dias": 1,
            "Texto": "diaria"
        }
    },
    {
        "id": 17,
        "Principio activo": "Zeposia",
        "Presentación": "Ozanimod Zeposia® 0,23-0,46 mg 4-3 cápsulas duras",
        "mg": 0.23,
        "Unidades": 4,
        "PVL": 305.97,
        "PF": 68.12,
        "Pus": '',
        "RDL": 7.5,
        "Presentación reducida": "Ozanimod Zeposia®",
        "Dias de carga": 7,
        "Unidades carga": 1,
        "Unidades posteriores": 12,
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 1,
            "Dias": 4,
            "Texto": "días 1-4"
        }
    },
    /*{
        "id": 23,
        "Principio activo": "Vumerity",
        "Presentación": "Vumerity® 462mg x 120 comprimidos",
        "mg": 462,
        "Unidades": 120,
        "PVL": 1208.7,
        "PF": 817.48,
        "Pus": '',
        "RDL": 0.0,
        "Administración": "Oral",
        "Presentación reducida": "Vumerity®",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 2,
            "Dias": 1,
            "Texto": "diarias"
        }
    },*/
    {
        "id": 24,
        "Principio activo": "Vumerity",
        "Presentación": "Vumerity® 231mg x 120 comprimidos",
        "mg": 231,
        "Unidades": 120,
        "PVL": 1208.7,
        "PF": 817.48,
        "Pus": '',
        "RDL": 7.5,
        "Administración": "Oral",
        "Presentación reducida": "Vumerity® 231mg x 120 comprimidos",
        "Dias de carga": 7,
        "Unidades carga": 2,
        "Unidades posteriores": 12,
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 2,
            "Dias": 7,
            "Texto": "días 1-7"
        },
        "FrecuenciaUniR": {
            "Unidades": 4,
            "Dias": 1,
            "Texto": "diarias"
        }
    },
    {
        "id": 25,
        "Principio activo": "Ponvory",
        "Presentación": "Ponvory® 20mg x 28 comprimidos",
        "mg": 20,
        "Unidades": 28,
        "PVL": 100.00,
        "PF": 100.00,
        "Pus": '',
        "RDL": 0.0,
        "Presentación reducida": "Ponvory®",
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 1,
            "Dias": 1,
            "Texto": "diarias"
        }
    },
    {
        "id": 26,
        "Principio activo": "Ponvory",
        "Presentación": "Ponvory 83mg x 14 comprimidos",
        "mg": 83,
        "Unidades": 14,
        "PVL": 100.00,
        "PF": 100.00,
        "Pus": '',
        "RDL": 0.0,
        "Presentación reducida": "Ponvory®",
        "Dias de carga": 7,
        "Unidades carga": 2,
        "Unidades posteriores": 12,
        "EsAnual": false,
        "FrecuenciaUni": {
            "Unidades": 14,
            "Dias": 14,
            "Texto": "días 1-14"
        }
    },
];

export const emrrData = {
    'emrr': 0.001,
    'nuevos': 0.1,
    'swift': 0.105
};

export const epidemiologia = {
    "España": {
        "Poblacion": 49733038
    },
    "Andalucía": {
        "Poblacion": 8412966
    },
    "Aragón": {
        "Poblacion": 1313581
    },
    "Asturias": {
        "Poblacion": 1033505
    },
    "Baleares": {
        "Poblacion": 1142860
    },
    "Canarias": {
        "Poblacion": 2145987
    },
    "Cantabria": {
        "Poblacion": 580796
    },
    "Castilla y León": {
        "Poblacion": 2436850
    },
    "Castilla la Mancha": {
        "Poblacion": 2040678
    },
    "Cataluña": {
        "Poblacion": 7407921
    },
    "Comunidad Valenciana": {
        "Poblacion": 4929876
    },
    "Extremadura": {
        "Poblacion": 1081017
    },
    "Galicia": {
        "Poblacion": 2708036
    },
    "Madrid": {
        "Poblacion": 6462383
    },
    "Murcia": {
        "Poblacion": 1467538
    },
    "Navarra": {
        "Poblacion": 637456
    },
    "País Vasco": {
        "Poblacion": 2159711
    },
    "La Rioja": {
        "Poblacion": 311675
    },
    "Ceuta": {
        "Poblacion": 85025
    },
    "Melilla": {
        "Poblacion": 85388
    }
};

export const costesFarmacosSimulaciones_default = {
    1: {
        "Simulacion 1": {
            "Utilización": 4.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 4.0,
            "Pacientes": 0
        }
    },
    2: {
        "Simulacion 1": {
            "Utilización": 4.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 4.0,
            "Pacientes": 0
        }
    },
    3: {
        "Simulacion 1": {
            "Utilización": 6.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 5.5,
            "Pacientes": 0
        }
    },
    5: {
        "Simulacion 1": {
            "Utilización": 2.5,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 2.5,
            "Pacientes": 0
        }
    },
    21: {
        "Simulacion 1": {
            "Utilización": 2.5,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 2.5,
            "Pacientes": 0
        }
    },
    7: {
        "Simulacion 1": {
            "Utilización": 3.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 3.0,
            "Pacientes": 0
        }
    },
    18: {
        "Simulacion 1": {
            "Utilización": 3.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 3.0,
            "Pacientes": 0
        }
    },
    8: {
        "Simulacion 1": {
            "Utilización": 17.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 15.0,
            "Pacientes": 0
        }
    },
    10: {
        "Simulacion 1": {
            "Utilización": 12.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 11.0,
            "Pacientes": 0
        }
    },
    11: {
        "Simulacion 1": {
            "Utilización": 7.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 6.5,
            "Pacientes": 0
        }
    },
    12: {
        "Simulacion 1": {
            "Utilización": 19.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 17.0,
            "Pacientes": 0
        }
    },
    13: {
        "Simulacion 1": {
            "Utilización": 4.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 3.5,
            "Pacientes": 0
        }
    },
    20: {
        "Simulacion 1": {
            "Utilización": 4.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 3.5,
            "Pacientes": 0
        }
    },
    14: {
        "Simulacion 1": {
            "Utilización": 11.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 9.0,
            "Pacientes": 0
        }
    },
    15: {
        "Simulacion 1": {
            "Utilización": 1.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 1.0,
            "Pacientes": 0
        }
    },
    16: {
        "Simulacion 1": {
            "Utilización": 0.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 9.0,
            "Pacientes": 0
        }
    },
    24: {
        "Simulacion 1": {
            "Utilización": 1.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 1.0,
            "Pacientes": 0
        }
    },
    25: {
        "Simulacion 1": {
            "Utilización": 0.0,
            "Pacientes": 0
        },
        "Simulacion 2": {
            "Utilización": 0.0,
            "Pacientes": 0
        }
    }
};

export const flujoPacientes_default = {
    1: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    },
    2: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    },
    3: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    },
    5: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    },
    21: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    },
    7: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    },
    18: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    },
    8: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    },
    10: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    },
    11: {
        "Año 1": 50,
        "Año 2": 50
    },
    12: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    },
    13: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    },
    20: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    },
    14: {
        "Semestre 1": 50,
        "Semestre 2": 50
    },
    15: {
        "Año 1": 50,
        "Año 2": 50
    },
    16: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    },
    24: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    },
    25: {
        "Q1": 25,
        "Q2": 25,
        "Q3": 25,
        "Q4": 25
    }
};
export const tasaBrotes_default = {
    1: {
        "Tasa": 0.3495
    },
    2: {
        "Tasa": 0.4449
    },
    3: {
        "Tasa": 0.3495
    },
    5: {
        "Tasa": 0.3389
    },
    21: {
        "Tasa": 0.3389
    },
    7: {
        "Tasa": 0.3442
    },
    18: {
        "Tasa": 0.3442
    },
    8: {
        "Tasa": 0.2807
    },
    10: {
        "Tasa": 0.3787
    },
    11: {
        "Tasa": 0.2224
    },
    12: {
        "Tasa": 0.2489
    },
    13: {
        "Tasa": 0.1642
    },
    20: {
        "Tasa": 0.1642
    },
    14: {
        "Tasa": 0.1907
    },
    15: {
        "Tasa": 0.1589
    },
    16: {
        "Tasa": 0.2542
    },
    24: {
        "Tasa": 0.1290
    },
    25: {
        "Tasa": 0.2807
    }
};


export const valores_default = {
    costesFarmacilogicos: [
        {
            key: "PVL",
            text: "PVL",
            value: "PVL"
        },
        {
            key: "PF",
            text: "PF",
            value: "PF"
        },
        {
            key: "Pus",
            text: "Pus",
            value: "Pus"
        }
    ],
    incluirIva: [
        {
            key: "SI",
            text: "SI",
            value: "SI"
        },
        {
            key: "NO",
            text: "NO",
            value: "NO"
        }
    ],
    incluirRDL: [
        {
            key: "SI",
            text: "SI",
            value: "SI"
        },
        {
            key: "NO",
            text: "NO",
            value: "NO"
        }
    ],
    incluirBrotes: [
        {
            key: "SI",
            text: "SI",
            value: "SI"
        },
        {
            key: "NO",
            text: "NO",
            value: "NO"
        }
    ],
    incluirPacientes: [
        {
            key: "Pacientes",
            text: "Pacientes",
            value: "Pacientes"
        },
        {
            key: "Porcentaje",
            text: "Porcentaje",
            value: "Porcentaje"
        }
    ],
    tipoPacientes: [
        {
            key: "Manual",
            text: "Manual",
            value: "Manual"
        },
        {
            key: "Territorial",
            text: "Territorial",
            value: "Territorial"
        }
    ],
    incluirAdministracion: [
        {
            key: "SI",
            text: "SI",
            value: "SI"
        },
        {
            key: "NO",
            text: "NO",
            value: "NO"
        }
    ]
}

export const costesFarmacos = {
    getValores: async function () { //costesFarmacos
        return await localforage.getItem('costesFarmacos', function (err, value) {
            return value
        });
    },
}

export const costesFarmacosSimulaciones = {
    getValores: async function () { //costesFarmacos
        return await localforage.getItem('costesFarmacosSimulaciones', function (err, value) {
            return value
        });
    },
}
export const inputsAdministracion = {
    getValores: async function () { //costesFarmacos
        return await localforage.getItem('inputsAdministracion', function (err, value) {
            return value
        });
    },
}
export const flujoPacientes = {
    getValores: async function () { //costesFarmacos
        return await localforage.getItem('flujoPacientes', function (err, value) {
            return value
        });
    },
}
export const tasaBrotes = {
    getValores: async function () { //costesFarmacos
        return await localforage.getItem('tasaBrotes', function (err, value) {
            return value
        });
    },
}
export const costeCohorte = {
    getValores: async function () { //costesFarmacos
        return await localforage.getItem('costeCohorte', function (err, value) {
            return value
        });
    },
}
export const costesFarmacosAnuales = {
    getValores: async function () { //costesFarmacos
        return await localforage.getItem('costesFarmacosAnuales', function (err, value) {
            return value
        });
    },
}
export const costesCohorteAnuales = {
    getValores: async function () { //costesFarmacos
        return await localforage.getItem('costesCohorteAnuales', function (err, value) {
            return value
        });
    },
}
export const resultados = {
    getValores: async function () { //costesFarmacos
        return await localforage.getItem('resultados', function (err, value) {
            return value
        });
    },
}

export const seleccionPrecio_default = {
    "precio_valorar": "PVL",
    "incluir_iva": "NO",
    "incluir_rdl": "NO"
}
export const crearTipoPrecio = {
    createTipoPrecio: async function (tipoPrecio) {
        await localforage.setItem('seleccionPrecio', tipoPrecio)
    }
}
export const crearVerIva = {
    createTipoPrecio: async function (verIva) {
        await localforage.setItem('verIva', verIva)
    }
}
export const crearVerDescuento = {
    createTipoPrecio: async function (verDescuento) {
        await localforage.setItem('verDescuento', verDescuento)
    }
}
export const crearVerBrotes = {
    createTipoPrecio: async function (verBrotes) {
        await localforage.setItem('verBrotes', verBrotes)
    }
}
export const seleccionPrecio = {
    getValores: async function () {
        return await localforage.getItem('seleccionPrecio', function (err, value) {
            return value
        });
    },
}
export const numeroPacientes_default = {
    "n_pacientes": 100,
    "incluir_pacientes": "Porcentaje",
    "tipo_pacientes": "Territorial"
}
export const crearIncluirPacientes = {
    createIncluirPacientes: async function (incluirPacientes) {
        await localforage.setItem('incluirPacientes', incluirPacientes)
    }
}
export const crearTipoPacientes = {
    createTipoPacientes: async function (tipoPacientes) {
        await localforage.setItem('tipoPacientes', tipoPacientes)
    }
}
export const crearIncluirAdministracion = {
    createIncluirAdmin: async function (incluirAdministracion) {
        await localforage.setItem('incluirAdministracion', incluirAdministracion)
    }
}
export const crearSimulacion1 = {
    createIncluirAdmin: async function (simulacion1) {
        await localforage.setItem('simulacion1', simulacion1)
    }
}
export const crearSimulacion2 = {
    createIncluirAdmin: async function (simulacion2) {
        await localforage.setItem('simulacion2', simulacion2)
    }
}

export const pesoPaciente_default = 70;
export const inputsAdmis_default = {
    "incluir_coste_admin": "SI",
    "pacientes_admin": {
        "Simulacion 1": {
            "Porcentaje": 36,
            "Numero": 0
        },
        "Simulacion 2": {
            "Porcentaje": 20,
            "Numero": 0
        }
    },
    "coste_enfermeria": 32.98,
    "coste_hospital": 240.60
};
export const inputsBrotes_default = {
    "incluir_coste_brotes": "SI",
    "intesidad_leve": {
        "Porcentaje": 40,
        "Coste": 333.91
    },
    "intesidad_moderada": {
        "Porcentaje": 40,
        "Coste": 1065.00
    },
    "intesidad_grave": {
        "Porcentaje": 20,
        "Coste": 3708.31
    },
    "coste_ponderado": ((40 / 100) * 333.91) + ((40 / 100) * 1065) + ((20 / 100) * 3708.31)
};

export const calcular = {
    costesFarmacos: async function () {
        let tipoPrecioAnt = window.sessionStorage.getItem('seleccionPrecio')
        let verIva = window.sessionStorage.getItem('verIva')
        let verDescuento = window.sessionStorage.getItem('verDescuento')
        let peso = window.sessionStorage.getItem('pesoPromedio')
        // let tipoPrecioAnt = "PVL"
        // let verIva = "NO"
        // let verDescuento = "NO"
        let costes = await costesFarmacos.getValores()
        //let precio = await seleccionPrecio.getValores()
        const rows = [
            'Precio seleccionado',
            'Unidades envase',
            'Frecuencia unidades',
            'Frecuencia unidadesR',
            'Unidades año',
            'Unidades añoR',
            'Envases año',
            'Envases añoR',
            'Año 2',
            'Trimestral',
            'Semestral',
            'Coste Carga',
            'Unidades carga',
            'Unidades posteriores',
            'Coste año 1',
            'Coste Q1 con carga',
            'Año 1'
        ]
        let cRebif = 0;
        let cSelRebif = 0;
        let cPlegridy = 0;
        let cSelPlegridy1 = 0;
        let cSelPlegridy2 = 0;
        let cTecfidera = 0;
        let uTecfidera = 0;
        let cSelTecfidera = 0;
        let cZeposia = 0;
        let uZeposia = 0;
        let cSelZeposia = 0;

        let cVumerity = 0;
        let uVumerity = 0;
        let cSelVumerity = 0;
        let cPonvory = 0;
        let uPonvory = 0;
        let cSelPonvory = 0;
        costes.forEach(coste => {
            //console.log(coste["EsAnual"])
            rows.forEach(row => {
                switch (row) {
                    case 'Precio seleccionado':
                        let precioBase = tipoPrecioAnt === 'PVL' ? coste['PVL'] : tipoPrecioAnt === 'PF' ? coste['PF'] : coste['Pus'];
                        let iva = verIva === 'SI' ? 1.04 : 1;
                        let rdl = verDescuento === 'SI' ? (1 - (1 * (coste['RDL'] / 100))) : (1 - (0 * (coste['RDL'] / 100)));
                        let total = precioBase * iva * rdl;
                        coste[row] = total;
                        break;
                    case 'Unidades envase':
                        coste[row] = coste['Unidades'];
                        break;
                    case 'Frecuencia unidades':
                        let fre = Array.isArray(coste['FrecuenciaUni']['Unidades']) ? coste['FrecuenciaUni']['Unidades'][0] : coste['FrecuenciaUni']['Unidades'];
                        if (coste.id == 11) {
                            let pComp = comp10mgPorPeso.filter(x => x.min <= peso && x.max >= peso)
                            //console.log(pComp)
                            fre = pComp[0]["semana 1"] + pComp[0]["semana 2"];
                        } else if (coste.id == 19) {
                            let pComp = comp10mgPorPeso.filter(x => x.min <= peso && x.max >= peso)
                            let pNum = pComp[0]["semana 1"] + pComp[0]["semana 2"];
                            costes.forEach(AuxCoste => {
                                if (AuxCoste.id == 11) {
                                    let auxUni = pNum - (AuxCoste['Unidades envase'] * AuxCoste['Envases año']);
                                    fre = auxUni;
                                }
                            })
                        } else if (coste.id == 24) {
                            let freR = Array.isArray(coste['FrecuenciaUniR']['Unidades']) ? coste['FrecuenciaUniR']['Unidades'][0] : coste['FrecuenciaUniR']['Unidades'];
                            coste[row + 'R'] = freR + ' ' + coste['FrecuenciaUniR']['Texto'];
                        }
                        coste[row] = fre + ' ' + coste['FrecuenciaUni']['Texto'];
                        break;
                    case 'Unidades año':
                        if (coste.id == 3 || coste.id == 6 || coste.id == 9 || coste.id == 17 || coste.id == 22 || coste.id == 24 || coste.id == 26) {
                            let frec = Array.isArray(coste['FrecuenciaUni']['Unidades']) ? coste['FrecuenciaUni']['Unidades'][0] : coste['FrecuenciaUni']['Unidades'];
                            //console.log(frec)
                            let sum = coste.id == 6 || coste.id == 22 ? (coste['FrecuenciaUni']['Dias']) : (coste['FrecuenciaUni']['Dias'] * frec);
                            sum = coste.id == 3 ? (coste['FrecuenciaUni']['Unidades'] * 4) : sum;
                            //console.log(sum)
                            if (coste.id == 24) {
                                let freR = Array.isArray(coste['FrecuenciaUniR']['Unidades']) ? coste['FrecuenciaUniR']['Unidades'][0] : coste['FrecuenciaUniR']['Unidades'];
                                //let sumR = (coste['FrecuenciaUniR']['Dias'] * freR);
                                let sumR = (365 / coste['FrecuenciaUniR']['Dias']) * freR;
                                coste[row + 'R'] = sumR;
                            }
                            coste[row] = sum;
                        } else {
                            let frec = Array.isArray(coste['FrecuenciaUni']['Unidades']) ? coste['FrecuenciaUni']['Unidades'][0] : coste['FrecuenciaUni']['Unidades'];
                            if (coste.id == 11) {
                                let pComp = comp10mgPorPeso.filter(x => x.min <= peso && x.max >= peso)
                                frec = pComp[0]["semana 1"];
                            }
                            if (coste.id == 19) {
                                let pComp = comp10mgPorPeso.filter(x => x.min <= peso && x.max >= peso)
                                let pNum = pComp[0]["semana 1"] + pComp[0]["semana 2"];
                                costes.forEach(AuxCoste => {
                                    if (AuxCoste.id == 11) {
                                        let auxUni = pNum - (AuxCoste['Unidades envase'] * AuxCoste['Envases año']);
                                        frec = auxUni;
                                    }
                                })
                            }
                            //console.log(frec)
                            let sum = (365 / coste['FrecuenciaUni']['Dias']) * frec;
                            /*switch (coste.id) {
                                case 1:
                                    sum = (365 / coste['FrecuenciaUni']['Dias']) * frec;
                                    break;
                                case 2:
                                case 4:
                                case 18:
                                case 13:
                                case 20:
                                    sum = Math.floor(365 / coste['FrecuenciaUni']['Dias']) * frec;
                                    break;
                                case 5:
                                case 21:
                                case 14:
                                    sum = Math.ceil(365 / coste['FrecuenciaUni']['Dias']) * frec;
                                    break;
                                case 11:
                                    sum = 2 * frec;
                                    break;
                                default:
                                    sum = (365 / coste['FrecuenciaUni']['Dias']) * frec;
                            }*/
                            //console.log(sum)
                            coste[row] = sum;
                        }
                        break;
                    case 'Envases año':
                        let sum = coste.id == 11 ? Math.floor(coste['Unidades año'] / coste['Unidades']) : (coste['Unidades año'] / coste['Unidades']);
                        if (coste.id == 24) {
                            let sumR = (coste['Unidades añoR'] / coste['Unidades']);
                            coste[row + 'R'] = sumR;
                        }
                        /*switch (coste.id) {
                            case 1:
                                sum = (coste['Unidades año'] / coste['Unidades']);
                                break;
                            case 2:
                            case 4:
                            case 18:
                            case 13:
                            case 20:
                                sum = Math.floor(365 / coste['FrecuenciaUni']['Dias']) * frec;
                                break;
                            case 5:
                            case 21:
                            case 14:
                                sum = Math.ceil(365 / coste['FrecuenciaUni']['Dias']) * frec;
                                break;
                            case 11:
                                sum = 2 * frec;
                                break;
                            default:
                                sum = (365 / coste['FrecuenciaUni']['Dias']) * frec;
                        }*/
                        coste[row] = sum;
                        break;
                    case 'Año 2':
                        if (coste.id == 19) {
                            costes.forEach(AuxCoste => {
                                if (AuxCoste.id == 11) {
                                    AuxCoste[row] = AuxCoste[row] + (coste['Precio seleccionado'] * coste['Envases año'])
                                    AuxCoste[row + '2'] = AuxCoste[row + '2'] + (coste['Precio seleccionado'] * coste['Envases año'])
                                }
                            })
                        }
                        let sum2 = coste['Precio seleccionado'] * coste['Envases año'];
                        if (coste.id == 24) {
                            sum2 = coste['Precio seleccionado'] * coste['Envases añoR'];
                        }
                        coste[row] = sum2;
                        break;
                    case 'Trimestral':
                        coste[row] = coste['Año 2'] / 4;
                        break;
                    case 'Semestral':
                        coste[row] = coste['Año 2'] / 2;
                        break;
                    case 'Coste Carga':
                        coste[row] = coste['Año 2'];
                        break;
                    case 'Días mantenimiento':
                        coste[row] = (365 / 4) - coste['Dias de carga'];
                        break;
                    case 'Unidades carga':
                        coste[row] = coste.id == 24 ? coste['Envases año'] : coste['Unidades carga'];
                        break;
                    case 'Unidades posteriores':
                        let suma = coste['Unidades posteriores'];
                        if (coste.id == 9 || coste.id == 17) {
                            suma = coste.id == 9 ? 716 / uTecfidera : 358 / uZeposia;
                        }
                        if (coste.id == 26) {
                            suma = coste.id == 24 ? 358 / uVumerity : 351 / uPonvory;
                        }
                        if (coste.id == 24) {
                            suma = coste['Envases añoR'] - (coste['Unidades carga'] * 2);
                        }
                        coste[row] = suma;
                        break;
                    case 'Coste año 1':
                        let cAnio1 = 0;
                        switch (coste.id) {
                            case 3:
                                cAnio1 = (coste['Unidades posteriores'] * cSelRebif) + (coste['Coste Carga'] * coste['Unidades carga']);
                                break;
                            case 6:
                                cAnio1 = (coste['Unidades posteriores'] * cSelPlegridy1) + (coste['Coste Carga']);
                                break;
                            case 9:
                                cAnio1 = (coste['Unidades posteriores'] * cSelTecfidera) + (coste['Coste Carga']);
                                break;
                            case 17:
                                cAnio1 = (coste['Unidades posteriores'] * cSelZeposia) + (coste['Coste Carga']);
                                break;
                            case 22:
                                cAnio1 = (coste['Unidades posteriores'] * cSelPlegridy2) + (coste['Coste Carga']);
                                break;
                            case 24:
                                cAnio1 = (coste['Unidades posteriores'] + coste['Unidades carga']) * coste['Precio seleccionado'];
                                break;
                            case 26:
                                cAnio1 = (coste['Unidades posteriores'] * cSelPonvory) + (coste['Coste Carga']);
                                break;
                        }
                        coste[row] = cAnio1;
                        break;
                    case 'Coste mantenimiento':
                        if (coste.id == 3) {
                            coste[row] = (cRebif * coste['Días mantenimiento']) / 365
                        }
                        if (coste.id == 6 || coste.id == 22) {
                            coste[row] = (cPlegridy * coste['Días mantenimiento']) / 365
                        }
                        if (coste.id == 9) {
                            coste[row] = (cTecfidera * coste['Días mantenimiento']) / 365
                        }
                        if (coste.id == 17) {
                            coste[row] = (cZeposia * coste['Días mantenimiento']) / 365
                        }
                        if (coste.id == 24) {
                            coste[row] = (cVumerity * coste['Días mantenimiento']) / 365
                        }
                        if (coste.id == 26) {
                            coste[row] = (cPonvory * coste['Días mantenimiento']) / 365
                        }
                        break;
                    case 'Coste Q1 con carga':
                        let cCarga1 = 0;
                        switch (coste.id) {
                            case 3:
                                let auxReb = 0;
                                costes.forEach(AuxCoste => {
                                    if (AuxCoste.id == 4) {
                                        auxReb = AuxCoste['Trimestral']
                                    }
                                })
                                //cCarga1 = (3 * cSelRebif) + (coste['Coste Carga']);
                                cCarga1 = coste['Coste año 1'] - (auxReb*3);
                                break;
                            case 6:
                                cCarga1 = (3 * cSelPlegridy1) + (coste['Coste Carga']);
                                break;
                            case 9:
                                let auxTec = 0;
                                costes.forEach(AuxCoste => {
                                    if (AuxCoste.id == 8) {
                                        auxTec = AuxCoste['Trimestral']
                                    }
                                })
                                // cCarga1 = (3 * cSelTecfidera) + (coste['Coste Carga']);
                                cCarga1 = coste['Coste año 1'] - (auxTec*3);
                                break;
                            case 17:
                                let auxZep = 0;
                                costes.forEach(AuxCoste => {
                                    if (AuxCoste.id == 16) {
                                        auxZep = AuxCoste['Trimestral']
                                    }
                                })
                                cCarga1 = coste['Coste año 1'] - (auxZep*3);
                                break;
                            case 22:
                                cCarga1 = (3 * cSelPlegridy2) + (coste['Coste Carga']);
                                break;
                            case 24:
                                cCarga1 = coste['Trimestral'] - (14 * (coste['Precio seleccionado'] / coste['Unidades']));
                                break;
                            case 26:
                                cCarga1 = (3 * cSelPonvory) + (coste['Coste Carga']);
                                break;
                        }
                        coste[row] = cCarga1;
                        break;
                    case 'Año 1':
                        let anio1 = coste['Año 2'];
                        switch (coste.id) {
                            case 3:
                                costes.forEach(AuxCoste => {
                                    if (AuxCoste.id == 4) {
                                        AuxCoste[row] = coste['Coste año 1'];
                                    }
                                })
                                break;
                            case 6:
                                costes.forEach(AuxCoste => {
                                    if (AuxCoste.id == 5) {
                                        AuxCoste[row] = coste['Coste año 1'];
                                    }
                                })
                                break;
                            /*case 9:
                                costes.forEach(AuxCoste => {
                                    if (AuxCoste.id == 8) {
                                        AuxCoste[row] = coste['Coste año 1'];
                                    }
                                })
                                break;*/
                            case 17:
                                costes.forEach(AuxCoste => {
                                    if (AuxCoste.id == 16) {
                                        AuxCoste[row] = coste['Coste año 1'];
                                    }
                                })
                                break;
                            case 22:
                                costes.forEach(AuxCoste => {
                                    if (AuxCoste.id == 21) {
                                        AuxCoste[row] = coste['Coste año 1'];
                                    }
                                })
                                break;
                            case 24:
                                anio1 = coste['Coste año 1'] - (14 * (coste['Precio seleccionado'] / coste['Unidades']));
                                break;
                        }
                        coste[row] = anio1;
                        break;
                }
            })
            if (coste['id'] === 4) {
                cRebif = coste['Trimestral'];
                cSelRebif = coste['Precio seleccionado'];
            }
            if (coste['id'] === 5) {
                cPlegridy = coste['Anual'];
                cSelPlegridy1 = coste['Precio seleccionado'];
            }
            if (coste['id'] === 21) {
                cSelPlegridy2 = coste['Precio seleccionado'];
            }
            if (coste['id'] === 8) {
                cTecfidera = coste['Anual'];
                uTecfidera = coste['Unidades envase'];
                cSelTecfidera = coste['Precio seleccionado'];
            }
            if (coste['id'] === 16) {
                cZeposia = coste['Anual'];
                uZeposia = coste['Unidades envase'];
                cSelZeposia = coste['Precio seleccionado'];
            }
            if (coste['id'] === 23) {
                cVumerity = coste['Anual'];
                uVumerity = coste['Unidades envase'];
                cSelVumerity = coste['Precio seleccionado'];
            }
            if (coste['id'] === 25) {
                cPonvory = coste['Anual'];
                uPonvory = coste['Unidades envase'];
                cSelPonvory = coste['Precio seleccionado'];
            }
            if (coste["EsAnual"]) {
                //console.log('es anual')
                rows.forEach(row => {
                    switch (row) {
                        case 'Precio seleccionado':
                            let precioBase = tipoPrecioAnt === 'PVL' ? coste['PVL'] : tipoPrecioAnt === 'PF' ? coste['PF'] : coste['Pus'];
                            let iva = verIva === 'SI' ? 1.04 : 1;
                            let rdl = verDescuento === 'SI' ? (1 - (1 * (coste['RDL'] / 100))) : (1 - (0 * (coste['RDL'] / 100)));
                            let total = precioBase * iva * rdl;
                            coste[row + '2'] = total;
                            break;
                        case 'Unidades envase':
                            coste[row + '2'] = coste['Unidades'];
                            break;
                        case 'Frecuencia unidades':
                            let fre = Array.isArray(coste['FrecuenciaUni']['Unidades']) ? coste['FrecuenciaUni']['Unidades'][1] : coste['FrecuenciaUni']['Unidades'];
                            if (coste.id == 11) {
                                let pComp = comp10mgPorPeso.filter(x => x.min <= peso && x.max >= peso)
                                fre = pComp[0]["semana 1"] + pComp[0]["semana 2"];
                            }
                            coste[row + '2'] = fre + ' ' + coste['FrecuenciaUni']['Texto'];
                            break;
                        case 'Unidades año':
                            let frec = Array.isArray(coste['FrecuenciaUni']['Unidades']) ? coste['FrecuenciaUni']['Unidades'][1] : coste['FrecuenciaUni']['Unidades'];
                            if (coste.id == 11) {
                                let pComp = comp10mgPorPeso.filter(x => x.min <= peso && x.max >= peso)
                                frec = pComp[0]["semana 1"];
                            }
                            //console.log(frec)
                            let sum = (365 / coste['FrecuenciaUni']['Dias']) * frec;
                            /*switch (coste.id) {
                                case 1:
                                    sum = (365 / coste['FrecuenciaUni']['Dias']) * frec;
                                    break;
                                case 2:
                                case 4:
                                case 18:
                                    sum = Math.floor(365 / coste['FrecuenciaUni']['Dias']) * frec;
                                    break;
                                case 5:
                                case 21:
                                    sum = Math.ceil(365 / coste['FrecuenciaUni']['Dias']) * frec;
                                    break;
                                case 11:
                                    sum = 2 * frec;
                                    break;
                                default:
                                    sum = (365 / coste['FrecuenciaUni']['Dias']) * frec;
                            }*/
                            //console.log(sum)
                            coste[row + '2'] = sum;
                            break;
                        case 'Envases año':
                            coste[row + '2'] = coste.id == 11 ? Math.floor(coste['Unidades año2'] / coste['Unidades']) : (coste['Unidades año2'] / coste['Unidades']);
                            break;
                        case 'Año 2':
                            coste[row + '2'] = coste['Precio seleccionado2'] * coste['Envases año2'];
                            break;
                        case 'Trimestral':
                            coste[row + '2'] = coste['Año 22'] / 4;
                            break;
                        case 'Semestral':
                            coste[row + '2'] = coste['Año 22'] / 2;
                            break;
                        case 'Año 1':
                            let anio1 = 0;
                            if (coste.id != 11) {
                                anio1 = 1
                            }
                            coste[row + '2'] = anio1;
                            break;
                    }
                })
            }
        })
        await localforage.setItem('costesFarmacos', costes)
        //console.log(costes);
        //let costesRaw = await localforage.getItem('costesFarmacos')
        this.simulaciones()
        return false;
    },

    simulaciones: async function () {
        let simulaciones = await costesFarmacosSimulaciones.getValores()
        // let simulaciones = costesFarmacosSimulaciones_default
        let numPacientes = window.sessionStorage.getItem("numPacientes");
        //let numPacientes = 100;
        let incluir = window.sessionStorage.getItem("incluirPacientes");
        if (incluir === "Porcentaje") { //En el caso de que seleccionen Porcentaje
            Object.entries(simulaciones).map((sim, i) => {
                //console.log(sim)
                sim[1]["Simulacion 1"]['Valor'] = numPacientes * (sim[1]["Simulacion 1"]["Utilización"] / 100);
                sim[1]["Simulacion 2"]['Valor'] = numPacientes * sim[1]["Simulacion 2"]["Utilización"] / 100
            });
        } else { //En el caso que se seleccione Pacientes
            Object.entries(simulaciones).map((sim, i) => {
                //console.log(sim)
                sim[1]["Simulacion 1"]['Valor'] = sim[1]["Simulacion 1"]["Pacientes"];
                sim[1]["Simulacion 2"]['Valor'] = sim[1]["Simulacion 2"]["Pacientes"];
            });
        }
        await localforage.setItem('costesFarmacosSimulaciones', simulaciones)
        this.inputsAdmin()
    },

    inputsAdmin: async function () {
        let inputsAd = await inputsAdministracion.getValores()
        // let inputsAd = inputsAdmis_default
        let simulaciones = await costesFarmacosSimulaciones.getValores()
        let incluir = window.sessionStorage.getItem("incluirPacientes");
        // let incluir = "Porcentaje";
        let incluirAdm = window.sessionStorage.getItem("incluirAdministracion");
        // let incluirAdm = "SI";
        if (incluir === "Porcentaje") { //En el caso de que seleccionen Porcentaje
            let i70 = 0
            let l70 = 0
            Object.entries(simulaciones).map((sim, i) => {
                if (sim[0] == 2) {
                    i70 = sim[1]["Simulacion 1"]['Valor']
                    l70 = sim[1]["Simulacion 2"]['Valor']
                }
            });
            inputsAd['pacientes_admin']["Simulacion 1"]["Valor"] = i70 * (inputsAd['pacientes_admin']["Simulacion 1"]['Porcentaje'] / 100);
            inputsAd['pacientes_admin']["Simulacion 2"]["Valor"] = l70 * (inputsAd['pacientes_admin']["Simulacion 2"]['Porcentaje'] / 100);
        } else { //En el caso que se seleccione Pacientes
            inputsAd['pacientes_admin']["Simulacion 1"]["Valor"] = inputsAd['pacientes_admin']["Simulacion 1"]["Numero"];
            inputsAd['pacientes_admin']["Simulacion 2"]["Valor"] = inputsAd['pacientes_admin']["Simulacion 2"]["Numero"];
        }
        inputsAd['incluir_coste_admin'] = incluirAdm
        await localforage.setItem('inputsAdministracion', inputsAd)
        this.calculaAdministracion()
    },

    calculaAdministracion: async function () {
        const costes = await costesFarmacos.getValores()
        const inpAdmin = await inputsAdministracion.getValores();
        const flujo = await flujoPacientes.getValores();
        //console.log(inpAdmin);
        // const flujo = flujoPacientes_default
        let simulaciones = await costesFarmacosSimulaciones.getValores()
        let incluirAdm = window.sessionStorage.getItem("incluirAdministracion");
        // let incluirAdm = "SI";
        let nums = [1, 2];

        costes.map((coste, i) => {
            if (simulaciones[coste['id']]) {
                nums.map((simulacion, n) => {
                    let anual = 0;
                    let trimestral = 0;
                    let semestral = 0;
                    if (coste['id'] === 2 || coste['id'] === 13 || coste['id'] === 14 || coste['id'] === 15) {
                        if (coste['Principio activo'] === "Avonex") {
                            anual = incluirAdm == 'SI' ? coste['Unidades año'] * (inpAdmin['pacientes_admin']['Simulacion ' + simulacion]['Valor']) * (inpAdmin['coste_enfermeria']) : 0;
                            trimestral = anual / 4;
                            //semestral = anual / 2;
                        } else {
                            anual = incluirAdm == 'SI' ? coste['Unidades año'] * (inpAdmin['coste_hospital']) * (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor']) : 0;
                            if (typeof flujo[coste['id']]['Semestre 1'] !== 'undefined') {
                                semestral = anual / 2;
                                trimestral = 0;
                            } else {
                                trimestral = anual / 4;
                                semestral = 0;
                            }
                            if (coste["EsAnual"]) {
                                anual = incluirAdm == 'SI' ? coste['Unidades año'] * (inpAdmin['coste_hospital']) * (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor']) * (flujo[coste['id']]['Año 1'] / 100) : 0;
                                trimestral = 0;
                                semestral = 0;
                            }
                        }
                    }
                    simulaciones[coste['id']]['Simulacion ' + simulacion]['Anual'] = anual;
                    simulaciones[coste['id']]['Simulacion ' + simulacion]['Trimestral'] = trimestral;
                    simulaciones[coste['id']]['Simulacion ' + simulacion]['Semestral'] = semestral;
                    if (coste["EsAnual"]) {
                        anual = 0;
                        trimestral = 0;
                        semestral = 0;
                        if (coste['id'] === 2 || coste['id'] === 13 || coste['id'] === 14 || coste['id'] === 15) {
                            // if (coste['Principio activo'] === "Avonex") {
                            //     anual = incluirAdm == 'SI' ? coste['Unidades año2'] * (inpAdmin['pacientes_admin']['Simulacion ' + simulacion]['Valor']) * (inpAdmin['coste_enfermeria']) : 0;
                            //     trimestral = anual / 4;
                            //     //semestral = anual / 2;
                            // } else {
                            //     anual = incluirAdm == 'SI' ? coste['Unidades año2'] * (inpAdmin['coste_hospital']) * (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor']) * (flujo[coste['id']]['Año 1'] / 100) : 0;
                            //     if (typeof flujo[coste['id']]['Semestre 1'] !== 'undefined') {
                            //         trimestral = 0;
                            //         semestral = anual / 2;
                            //     } else {
                            //         trimestral = anual / 4;
                            //         semestral = 0;
                            //     }

                            // }
                            anual = incluirAdm == 'SI' ? coste['Unidades año2'] * (inpAdmin['coste_hospital']) * (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor']) * (flujo[coste['id']]['Año 2'] / 100) : 0;
                        }
                        simulaciones[coste['id']]['Simulacion ' + simulacion]['Anual2'] = anual;
                        simulaciones[coste['id']]['Simulacion ' + simulacion]['Trimestral2'] = trimestral;
                        simulaciones[coste['id']]['Simulacion ' + simulacion]['Semestral2'] = semestral;

                    }
                })
            }
        });

        await localforage.setItem('costesFarmacosSimulaciones', simulaciones)
        this.calculaBrotes()
    },

    calculaBrotes: async function () {
        const costes = await costesFarmacos.getValores()
        const simulaciones = await costesFarmacosSimulaciones.getValores()
        let brotes = await tasaBrotes.getValores();
        // let brotes = tasaBrotes_default;
        let costePonderado = window.sessionStorage.getItem("costePonderado");
        // let costePonderado = 1301.226;
        // let verBrotes = window.sessionStorage.getItem("verBrotes");
        let verBrotes = "SI";
        let nums = [1, 2];
        costes.map((coste, i) => {
            if (brotes[coste['id']]) {
                nums.map((simulacion, n) => {
                    let numBrotes = simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * brotes[coste['id']]['Tasa'];
                    let anual = verBrotes === 'SI' ? numBrotes * costePonderado : 0;
                    brotes[coste['id']]['Simulacion ' + simulacion] = { 'Brotes al año': numBrotes, 'Anual': anual }
                })
            }
        })
        await localforage.setItem('tasaBrotes', brotes)
        this.calculaCohorte()
    },

    calculaCohorte: async function () {
        const costes = await costesFarmacos.getValores()
        const simulaciones = await costesFarmacosSimulaciones.getValores()
        const flujo = await flujoPacientes.getValores()
        const brotes = await tasaBrotes.getValores()
        let cargas = [];
        costes.map((coste, i) => {
            if (coste['id'] == 4)
                cargas['Rebif'] = coste['Año 2']
            if (coste['id'] == 6)
                cargas['Plegridy'] = coste['Coste Q1 con carga']
            if (coste['id'] == 9)
                cargas['Tecfidera'] = coste['Coste Q1 con carga']
            if (coste['id'] == 17)
                cargas['Zeposia'] = coste['Coste Q1 con carga']
            if (coste['id'] == 23)
                cargas['Vumerity'] = coste['Coste Q1 con carga']
            if (coste['id'] == 26)
                cargas['Ponvory'] = coste['Coste Q1 con carga']
        })
        const rows = {
            "Producto": [],
            "Coste farmacologico": ["Q1", "Q2", "Q3", "Q4", "TOTAL"],
            "Coste administracion": ["Q1", "Q2", "Q3", "Q4", "TOTAL"],
            "Coste Brotes": ["TOTAL"],
            "Coste Anual": ["TOTAL"],
        }
        let trim = 0
        let totalesAux = {}
        let anios = [1, 2];
        let nums = [1, 2];
        //console.log(simulaciones)

        //console.log(cargas)
        costes.map((coste, i) => {
            if (coste['id'] == 4)
                trim = coste['Trimestral']
            if (simulaciones[coste['id']]) {
                totalesAux[coste['id']] = {};
                totalesAux[coste['id']]['Producto'] = coste['Presentación'];
                totalesAux[coste['id']]['Posicion'] = i;
                anios.map((anio, m) => {
                    totalesAux[coste['id']]['Año ' + anio] = {};
                    //console.log(totalesAux)
                    nums.map((simulacion, n) => {
                        //console.log('Simulacion ' + simulacion)
                        //let simulacion = 1;
                        totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion] = {};
                        //console.log(totalesAux)
                        let total = 0;
                        let totalAdm = 0;
                        let totalTotal = 0;
                        Object.entries(rows).map((row, i) => {
                            //console.log(row[0])
                            if (row[0] != 'Producto' && row[0] != 'Coste Brotes' && row[0] != 'Coste Anual')
                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion][row[0]] = { "Q1": 0, "Q2": 0, "Q3": 0, "Q4": 0, "TOTAL": 0 };
                            if (row[0] == 'Coste Brotes' || row[0] == 'Coste Anual')
                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion][row[0]] = { "TOTAL": 0 };
                            row[1].map((celda, j) => {
                                if (row[0] === 'Coste farmacologico') {
                                    switch (celda) {
                                        case "Q1":
                                            if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Semestre 1"] !== 'undefined') {
                                                //console.log('semestre')
                                                let sumSem = anio == 1 ? (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Semestre 1'] / 100) * 2 * coste['Semestral']) : (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Semestre 1'] / 100) * coste['Semestral']);
                                                total = total + sumSem;
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['Q1'] = sumSem;
                                                //return <td>{(Math.round(((simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Semestre 1'] / 100) * coste['Semestral']) + Number.EPSILON) * 100) / 100).toLocaleString('de-DE')} €</td>
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Año " + anio] !== 'undefined') {
                                                //console.log('año')
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['Q1'] = 0
                                                //return <td></td>
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Q1"] !== 'undefined') {
                                                //console.log('Q')
                                                let result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * coste['Año ' + anio]);
                                                //total = total + (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * coste['Anual']);
                                                if (coste['Principio activo'] === 'Rebif') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * (coste['Coste Carga'] + (3 * trim)));
                                                    if (anio === 2) {
                                                        result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * cargas['Rebif']);
                                                    }
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Plegridy') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * (cargas['Plegridy'] + (3 * coste['Trimestral'])));
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Tecfidera') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * (cargas['Tecfidera'] + (3 * coste['Trimestral'])));
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Zeposia') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * (cargas['Zeposia'] + (3 * coste['Trimestral'])));
                                                    if (anio === 2) {
                                                        result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * coste['Año 2']);
                                                    }
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Vumerity') {
                                                    // console.log(simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'])
                                                    // console.log(flujo[coste['id']]['Q1'] / 100)
                                                    // console.log(coste['Coste Q1 con carga'] + (3*coste['Trimestral']))
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * (coste['Trimestral']));
                                                    if (anio == 1)
                                                        // result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * (coste['Coste Q1 con carga']));
                                                        result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * (coste['Coste Q1 con carga'] + (3*coste['Trimestral'])));
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Ponvory') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * (cargas['Ponvory'] + (3 * coste['Trimestral'])));
                                                    //console.log(result)
                                                }
                                                total = total + result;
                                                //console.log(result)
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['Q1'] = result
                                                //console.log(totalesAux[coste['id']]['Simulacion ' + simulacion]['Coste farmacológico']['Q1'])
                                                //console.log(totalesAux)
                                                //return <td>{(Math.round((result + Number.EPSILON) * 100) / 100).toLocaleString('de-DE')} €</td>
                                            }
                                            break;
                                        case "Q2":
                                            if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Semestre 1"] !== 'undefined') {
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['Q2'] = ''
                                                //return <td></td>
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Año " + anio] !== 'undefined') {
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['Q2'] = ''
                                                //return <td></td>
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Q2"] !== 'undefined') {
                                                let result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q2'] / 100) * (coste['Trimestral'] * 3));
                                                //total = total + (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * coste['Anual']);
                                                if (coste['Principio activo'] === 'Rebif') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q2'] / 100) * (coste['Coste Carga'] + (2 * trim)));
                                                    if (anio === 2) {
                                                        result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * cargas['Rebif'] * 0.75);
                                                    }
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Plegridy') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q2'] / 100) * (cargas['Plegridy'] + (2 * coste['Trimestral'])));
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Tecfidera') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q2'] / 100) * (cargas['Tecfidera'] + (2 * coste['Trimestral'])));
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Zeposia') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q2'] / 100) * (cargas['Zeposia'] + (2 * coste['Trimestral'])));
                                                    if (anio === 2) {
                                                        result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * coste['Año 2'] * 0.75);
                                                    }
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Vumerity') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q2'] / 100) * (coste['Trimestral']));
                                                    if(anio === 1) {
                                                        result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q2'] / 100) * (coste['Coste Q1 con carga'] + (2*coste['Trimestral'])));
                                                    }
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Ponvory') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q2'] / 100) * (cargas['Ponvory'] + (2 * coste['Trimestral'])));
                                                    //console.log(result)
                                                }
                                                total = total + result;
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['Q2'] = result
                                                //return <td>{(Math.round((result + Number.EPSILON) * 100) / 100).toLocaleString('de-DE')} €</td>
                                            }
                                            break;
                                        case "Q3":
                                            if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Semestre 2"] !== 'undefined') {
                                                total = total + (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Semestre 2'] / 100) * coste['Semestral']);
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['Q3'] = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Semestre 2'] / 100) * coste['Semestral']);
                                                //return <td>{(Math.round(((simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Semestre 2'] / 100) * coste['Semestral']) + Number.EPSILON) * 100) / 100).toLocaleString('de-DE')} €</td>
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Año " + anio] !== 'undefined') {
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['Q3'] = ''
                                                //return <td></td>
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Q3"] !== 'undefined') {
                                                let result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q3'] / 100) * (coste['Trimestral'] * 2));
                                                //total = total + (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * coste['Anual']);
                                                if (coste['Principio activo'] === 'Rebif') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q3'] / 100) * (coste['Coste Carga'] + (trim)));
                                                    if (anio === 2) {
                                                        result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * cargas['Rebif'] * 0.5);
                                                    }
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Plegridy') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q3'] / 100) * (cargas['Plegridy'] + (coste['Trimestral'])));
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Tecfidera') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q3'] / 100) * (cargas['Tecfidera'] + (coste['Trimestral'])));
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Zeposia') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q3'] / 100) * (cargas['Zeposia'] + (coste['Trimestral'])));
                                                    if (anio === 2) {
                                                        result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * coste['Año 2'] * 0.5);
                                                    }
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Vumerity') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q3'] / 100) * (coste['Trimestral']));
                                                    if(anio === 1) {
                                                        result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q3'] / 100) * (coste['Coste Q1 con carga'] + coste['Trimestral']));
                                                    }
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Ponvory') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q3'] / 100) * (cargas['Ponvory'] + (coste['Trimestral'])));
                                                    //console.log(result)
                                                }
                                                total = total + result;
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['Q3'] = result
                                                //return <td>{(Math.round((result + Number.EPSILON) * 100) / 100).toLocaleString('de-DE')} €</td>
                                            }
                                            break;
                                        case "Q4":
                                            if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Semestre 2"] !== 'undefined') {
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['Q4'] = ''
                                                //return <td></td>
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Año " + anio] !== 'undefined') {
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['Q4'] = ''
                                                //return <td></td>
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Q4"] !== 'undefined') {
                                                let result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q4'] / 100) * (coste['Trimestral'] * 1));
                                                //total = total + (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * coste['Anual']);
                                                if (coste['Principio activo'] === 'Rebif') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q4'] / 100) * (coste['Coste Carga']));
                                                    if (anio === 2) {
                                                        result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * cargas['Rebif'] * 0.25);
                                                    }
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Plegridy') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q4'] / 100) * (cargas['Plegridy']));
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Tecfidera') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q4'] / 100) * (cargas['Tecfidera']));
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Zeposia') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q4'] / 100) * (cargas['Zeposia']));
                                                    if (anio === 2) {
                                                        result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q1'] / 100) * coste['Año 2'] * 0.25);
                                                    }
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Vumerity') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q4'] / 100) * (coste['Trimestral']));
                                                    if(anio === 1) {
                                                        result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q3'] / 100) * coste['Coste Q1 con carga']);
                                                    }
                                                    //console.log(result)
                                                }
                                                if (coste['Principio activo'] === 'Ponvory') {
                                                    result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]['Q4'] / 100) * (cargas['Ponvory']));
                                                    //console.log(result)
                                                }
                                                total = total + result;
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['Q4'] = result
                                                //return <td>{(Math.round((result + Number.EPSILON) * 100) / 100).toLocaleString('de-DE')} €</td>
                                            }
                                            break;
                                        case "TOTAL":
                                            if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Año " + anio] !== 'undefined') {
                                                //console.log(coste);
                                                // let result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]["Año "+anio] / 100) * coste['Año '+anio]) + (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]["Año "+anio] / 100) * coste['Año 12'])
                                                let result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]["Año " + anio] / 100) * coste['Año ' + anio])
                                                if (coste['Principio activo'] === 'Lemtrada') {
                                                    result = anio !== 2 ? (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]["Año 1"] / 100) * coste['Año 2']) : (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]["Año " + anio] / 100) * coste['Año ' + anio + "2"]);
                                                }
                                                // if (coste['Principio activo'] === 'Mavenclad') {
                                                //     if (anio === 1) {
                                                //     } else {
                                                //         result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Valor'] * (flujo[coste['id']]["Año " + anio] / 100) * coste['Año ' + anio])
                                                //     }
                                                // }
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['TOTAL'] = result;
                                                totalTotal = totalTotal + result;
                                                //return <td>{(Math.round((result + Number.EPSILON) * 100) / 100).toLocaleString('de-DE')} €</td>
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Semestre 1"] !== 'undefined') {
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['TOTAL'] = total;
                                                totalTotal = totalTotal + total;
                                                //totalesAux[coste['id']]['Simulacion ' + simulacion]['Coste farmacológico'] = total;
                                                //return <td>{(Math.round((total + Number.EPSILON) * 100) / 100).toLocaleString('de-DE')} €</td>
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Q4"] !== 'undefined') {
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste farmacologico']['TOTAL'] = total;
                                                totalTotal = totalTotal + total;
                                                //totalesAux[coste['id']]['Simulacion ' + simulacion]['Coste farmacológico'] = total;
                                                //return <td>{(Math.round((total + Number.EPSILON) * 100) / 100).toLocaleString('de-DE')} €</td>
                                            }
                                            break;
                                    }
                                }
                                if (row[0] === 'Coste administracion') {
                                    let result = 0;
                                    switch (celda) {
                                        case "Q1":
                                            if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Semestre 1"] !== 'undefined') {
                                                result = ((flujo[coste['id']]["Semestre 1"] / 100) * simulaciones[coste['id']]['Simulacion ' + simulacion]['Semestral']);
                                                totalAdm = totalAdm + result
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Año 1"] !== 'undefined') {
                                                result = '';
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Q1"] !== 'undefined') {
                                                result = ((flujo[coste['id']]["Q1"] / 100) * simulaciones[coste['id']]['Simulacion ' + simulacion]['Trimestral'] * 4);
                                                totalAdm = totalAdm + result;
                                            }
                                            totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste administracion']['Q1'] = result
                                            break;
                                        case "Q2":
                                            if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Semestre 1"] !== 'undefined') {
                                                result = '';
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Año 1"] !== 'undefined') {
                                                result = '';
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Q2"] !== 'undefined') {
                                                result = ((flujo[coste['id']]["Q2"] / 100) * simulaciones[coste['id']]['Simulacion ' + simulacion]['Trimestral'] * 3);
                                                totalAdm = totalAdm + result;
                                            }
                                            totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste administracion']['Q2'] = result
                                            break;
                                        case "Q3":
                                            if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Semestre 2"] !== 'undefined') {
                                                result = ((flujo[coste['id']]["Semestre 2"] / 100) * simulaciones[coste['id']]['Simulacion ' + simulacion]['Semestral']);
                                                totalAdm = totalAdm + result
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Año 1"] !== 'undefined') {
                                                result = '';
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Q3"] !== 'undefined') {
                                                result = ((flujo[coste['id']]["Q3"] / 100) * simulaciones[coste['id']]['Simulacion ' + simulacion]['Trimestral'] * 2)
                                                totalAdm = totalAdm + result;
                                            }
                                            totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste administracion']['Q3'] = result
                                            break;
                                        case "Q4":
                                            if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Semestre 2"] !== 'undefined') {
                                                result = '';
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Año 1"] !== 'undefined') {
                                                result = '';
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Q4"] !== 'undefined') {
                                                result = ((flujo[coste['id']]["Q4"] / 100) * simulaciones[coste['id']]['Simulacion ' + simulacion]['Trimestral'] * 1)
                                                totalAdm = totalAdm + result;
                                            }
                                            totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste administracion']['Q4'] = result
                                            break;
                                        case "TOTAL":
                                            if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Año 1"] !== 'undefined') {
                                                let result = (simulaciones[coste['id']]['Simulacion ' + simulacion]['Anual'] * (flujo[coste['id']]['Año 1'] / 100)) + (simulaciones[coste['id']]['Simulacion ' + simulacion]['Anual2'] * (flujo[coste['id']]['Año 2'] / 100))
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste administracion']['TOTAL'] = result;
                                                totalTotal = totalTotal + result;
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Semestre 1"] !== 'undefined') {
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste administracion']['TOTAL'] = totalAdm;
                                                totalTotal = totalTotal + totalAdm;
                                            } else if (typeof flujo[coste['id']] !== 'undefined' && typeof flujo[coste['id']]["Q4"] !== 'undefined') {
                                                totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste administracion']['TOTAL'] = totalAdm;
                                                totalTotal = totalTotal + totalAdm;
                                            }
                                            break;
                                    }
                                }
                                if (row[0] === 'Coste Brotes') {
                                    switch (celda) {
                                        case "TOTAL":
                                            totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste Brotes']['TOTAL'] = brotes[coste['id']]['Simulacion ' + simulacion]['Anual'];
                                            totalTotal = totalTotal + brotes[coste['id']]['Simulacion ' + simulacion]['Anual'];
                                            break;
                                    }
                                }
                                if (row[0] === 'Coste Anual') {
                                    totalesAux[coste['id']]['Año ' + anio]['Simulacion ' + simulacion]['Coste Anual']['TOTAL'] = totalTotal;
                                }
                            })
                        })
                    })
                })
            }

        });
        //console.log(totalesAux);
        await localforage.setItem('costeCohorte', totalesAux);
        this.calculaFarmacologicoAnual()
    },
    calculaFarmacologicoAnual: async function () {
        const costes = await costesFarmacos.getValores();
        const simulaciones = await costesFarmacosSimulaciones.getValores();
        const flujo = await flujoPacientes.getValores();
        const brotes = await tasaBrotes.getValores();
        const inpAdmin = await inputsAdministracion.getValores();
        let costePonderado = window.sessionStorage.getItem("costePonderado");
        let verMas = window.sessionStorage.getItem("verMasFarmAnual");
        const rows = {
            "Producto": [],
            "Año 1": ["Farmacologico", "Administracion", "Brotes", "TOTAL"],
            "Año 2": ["Farmacologico", "Administracion", "Brotes", "TOTAL"],
            "Diferencia 2-1": ["TOTAL"],
        }
        let totalesAux = {}
        costes.map((coste, n) => {
            totalesAux[coste['id']] = {};
            totalesAux[coste['id']]['Producto'] = coste['Presentación'];
            totalesAux[coste['id']]['Posicion'] = n;
            totalesAux[coste['id']]['Año 1'] = { "Farmacologico": 0, "Administracion": 0, "Brotes": 0, "TOTAL": 0 };
            totalesAux[coste['id']]['Año 2'] = { "Farmacologico": 0, "Administracion": 0, "Brotes": 0, "TOTAL": 0 };
            totalesAux[coste['id']]['Diferencia 2-1'] = { "TOTAL": 0 };

            Object.entries(rows).map((row, i) => {
                row[1].map((celda, j) => {
                    if (row[0] === 'Año 1') {
                        switch (celda) {
                            case "Farmacologico":
                                totalesAux[coste['id']][row[0]][celda] = coste['Principio activo'] === 'Mavenclad' ? coste["Año 2"] : coste[row[0]];
                                break;
                            case "Administracion":
                                //console.log(typeof simulaciones[coste['id']]);
                                let adm = coste['Unidades año'] * (inpAdmin['coste_hospital']);
                                if (coste['Principio activo'] === 'Avonex') {
                                    adm = (inpAdmin['pacientes_admin']['Simulacion 1']['Porcentaje'] / 100) * inpAdmin['coste_enfermeria'];
                                }
                                if (typeof simulaciones[coste['id']] === 'undefined' || simulaciones[coste['id']]['Simulacion 1']['Anual'] == 0) {
                                    adm = 0;
                                }
                                if (verMas == 0)
                                    adm = 0;
                                totalesAux[coste['id']][row[0]][celda] = adm;
                                break;
                            case "Brotes":
                                let br = typeof brotes[coste['id']] === 'undefined' ? 0 : brotes[coste['id']]['Tasa'] * costePonderado;
                                if (coste['id'] === 3) {
                                    totalesAux[4][row[0]][celda] = br;
                                }
                                if (verMas == 0)
                                    br = 0;
                                totalesAux[coste['id']][row[0]][celda] = br;
                                break;
                            case "TOTAL":
                                let total = totalesAux[coste['id']][row[0]]["Farmacologico"] + totalesAux[coste['id']][row[0]]["Administracion"] + totalesAux[coste['id']][row[0]]["Brotes"];
                                if (coste['id'] === 3) {
                                    totalesAux[4][row[0]][celda] = totalesAux[4][row[0]][celda] + totalesAux[coste['id']][row[0]]["Brotes"];
                                }
                                totalesAux[coste['id']][row[0]][celda] = total;
                                break;
                        }
                    }
                    if (row[0] === 'Año 2') {
                        switch (celda) {
                            case "Farmacologico":
                                totalesAux[coste['id']][row[0]][celda] = typeof coste["Año 22"] !== 'undefined' ? coste["Año 22"] : coste[row[0]];
                                break;
                            case "Administracion":
                                let adm = coste['Unidades año2'] ? coste['Unidades año2'] * (inpAdmin['coste_hospital']) : coste['Unidades año'] * (inpAdmin['coste_hospital']);
                                if (coste['Principio activo'] === 'Avonex') {
                                    adm = (inpAdmin['pacientes_admin']['Simulacion 1']['Porcentaje'] / 100) * inpAdmin['coste_enfermeria'];
                                }
                                if (typeof simulaciones[coste['id']] === 'undefined' || simulaciones[coste['id']]['Simulacion 1']['Anual'] == 0) {
                                    adm = 0;
                                }
                                if (verMas == 0)
                                    adm = 0;
                                totalesAux[coste['id']][row[0]][celda] = adm;
                                break;
                            case "Brotes":
                                let br = typeof brotes[coste['id']] === 'undefined' ? 0 : brotes[coste['id']]['Tasa'] * costePonderado;
                                if (coste['id'] === 3) {
                                    totalesAux[4][row[0]][celda] = br;
                                }
                                if (verMas == 0)
                                    br = 0;
                                totalesAux[coste['id']][row[0]][celda] = br;
                                break;
                            case "TOTAL":
                                let total = totalesAux[coste['id']][row[0]]["Farmacologico"] + totalesAux[coste['id']][row[0]]["Administracion"] + totalesAux[coste['id']][row[0]]["Brotes"];
                                if (coste['id'] === 3) {
                                    totalesAux[4][row[0]][celda] = totalesAux[4][row[0]][celda] + totalesAux[coste['id']][row[0]]["Brotes"];
                                }
                                totalesAux[coste['id']][row[0]][celda] = total;
                                break;
                        }
                    }
                    if (row[0] === 'Diferencia 2-1') {
                        switch (celda) {
                            case "TOTAL":
                                let total = totalesAux[coste['id']]['Año 2']["TOTAL"] - totalesAux[coste['id']]['Año 1']["TOTAL"];
                                totalesAux[coste['id']][row[0]][celda] = total;
                                break;
                        }
                    }
                })
            })
        });
        await localforage.setItem('costesFarmacosAnuales', totalesAux);
        this.calculaCohorteAnual();
    },
    calculaCohorteAnual: async function () {
        const cohorte = await costeCohorte.getValores()
        let verMas = window.sessionStorage.getItem("verMasCohorteAnual");

        let totalesAux = {}
        let anios = [1, 2];
        let simulaciones = [1, 2];
        /*Object.entries(cohorte).map((coste, n) => {
            totalesAux[coste[0]] = {};
            totalesAux[coste[0]]['Producto'] = coste[1]['Producto'];
            totalesAux[coste[0]]['Posicion'] = coste[1]['Posicion'];
            totalesAux[coste[0]]['Simulacion 1'] = { 'Año 1': { "Farmacologico": 0, "Administracion": 0, "Brotes": 0, "TOTAL": 0 }, 'Año 2': { "Farmacologico": 0, "Administracion": 0, "Brotes": 0, "TOTAL": 0 } }
            totalesAux[coste[0]]['Simulacion 2'] = { 'Año 1': { "Farmacologico": 0, "Administracion": 0, "Brotes": 0, "TOTAL": 0 }, 'Año 2': { "Farmacologico": 0, "Administracion": 0, "Brotes": 0, "TOTAL": 0 } }*/
        simulaciones.map((simulacion, s) => {
            totalesAux['Simulacion ' + simulacion] = {};
            Object.entries(cohorte).map((coste, n) => {
                totalesAux['Simulacion ' + simulacion][coste[0]] = {}
                totalesAux['Simulacion ' + simulacion][coste[0]]['Producto'] = coste[1]['Producto'];
                totalesAux['Simulacion ' + simulacion][coste[0]]['Posicion'] = coste[1]['Posicion'];
                anios.map((anio, a) => {
                    totalesAux['Simulacion ' + simulacion][coste[0]]["Año " + anio] = { "Farmacologico": 0, "Administracion": 0, "Brotes": 0, "TOTAL": 0 };
                    //console.log(totalesAux);
                    //return false;
                    totalesAux['Simulacion ' + simulacion][coste[0]]["Año " + anio]["Farmacologico"] = coste[1]["Año " + anio]['Simulacion ' + simulacion]["Coste farmacologico"]["TOTAL"];
                    totalesAux['Simulacion ' + simulacion][coste[0]]["Año " + anio]["Administracion"] = verMas == 1 ? coste[1]["Año " + anio]['Simulacion ' + simulacion]["Coste administracion"]["TOTAL"] : 0;
                    totalesAux['Simulacion ' + simulacion][coste[0]]["Año " + anio]["Brotes"] = verMas == 1 ? coste[1]["Año " + anio]['Simulacion ' + simulacion]["Coste Brotes"]["TOTAL"] : 0;
                    totalesAux['Simulacion ' + simulacion][coste[0]]["Año " + anio]["TOTAL"] = verMas == 1 ? coste[1]["Año " + anio]['Simulacion ' + simulacion]["Coste Anual"]["TOTAL"] : coste[1]["Año " + anio]['Simulacion ' + simulacion]["Coste Anual"]["TOTAL"] - (coste[1]["Año " + anio]['Simulacion ' + simulacion]["Coste Brotes"]["TOTAL"] + coste[1]["Año " + anio]['Simulacion ' + simulacion]["Coste administracion"]["TOTAL"]);
                })
            })
        })
        //});
        await localforage.setItem('costesCohorteAnuales', totalesAux);
        this.calculaResultados()
    },
    calculaResultados: async function () {
        const cohorte = await costeCohorte.getValores()
        let verMas = window.sessionStorage.getItem("verMasResultados");
        let totalesAux = {}
        let nums = [1, 2];

        const rows = {
            "Producto": '',
            "Posicion": '',
            "Simulacion 1": ["Farmacologico", "Administracion", "Brotes", "TOTAL"],
            "Simulacion 2": ["Farmacologico", "Administracion", "Brotes", "TOTAL"],
            "Diferencia 2-1": ["TOTAL"],
        }

        nums.map((anio, a) => {
            totalesAux['Año ' + anio] = {};
            Object.entries(cohorte).map((coste, i) => {
                totalesAux['Año ' + anio][coste[0]] = {}
                let total1 = 0;
                let total2 = 0;
                Object.entries(rows).map((row, j) => {
                    switch (row[0]) {
                        case 'Producto':
                            totalesAux['Año ' + anio][coste[0]][row[0]] = coste[1]['Producto']
                            break;
                        case 'Posicion':
                            totalesAux['Año ' + anio][coste[0]][row[0]] = coste[1]['Posicion']
                            break;
                        default:
                            totalesAux['Año ' + anio][coste[0]][row[0]] = {};
                            if (row[0] !== 'Diferencia 2-1') {
                                row[1].map((celda, h) => {
                                    if (row[0] === 'Simulacion 1') {
                                        if (celda !== 'TOTAL') {
                                            let celdaCohorte = celda == "Farmacologico" ? "Coste farmacologico" : (celda == "Administracion" ? "Coste administracion" : "Coste Brotes");
                                            if (celda === 'Farmacologico') {
                                                totalesAux['Año ' + anio][coste[0]][row[0]][celda] = Math.round((coste[1]['Año ' + anio][row[0]][celdaCohorte]['TOTAL'] + Number.EPSILON) * 100) / 100;
                                                total1 = total1 + Math.round((coste[1]['Año ' + anio][row[0]][celdaCohorte]['TOTAL'] + Number.EPSILON) * 100) / 100;
                                            } else {
                                                totalesAux['Año ' + anio][coste[0]][row[0]][celda] = verMas == 1 ? Math.round((coste[1]['Año ' + anio][row[0]][celdaCohorte]['TOTAL'] + Number.EPSILON) * 100) / 100 : 0;
                                                total1 = total1 + (verMas == 1 ? Math.round((coste[1]['Año ' + anio][row[0]][celdaCohorte]['TOTAL'] + Number.EPSILON) * 100) / 100 : 0);
                                            }
                                        } else {
                                            totalesAux['Año ' + anio][coste[0]][row[0]][celda] = total1;
                                        }
                                    }
                                    if (row[0] === 'Simulacion 2') {
                                        if (celda !== 'TOTAL') {
                                            let celdaCohorte = celda == "Farmacologico" ? "Coste farmacologico" : (celda == "Administracion" ? "Coste administracion" : "Coste Brotes");
                                            if (celda === 'Farmacologico') {
                                                totalesAux['Año ' + anio][coste[0]][row[0]][celda] = Math.round((coste[1]['Año ' + anio][row[0]][celdaCohorte]['TOTAL'] + Number.EPSILON) * 100) / 100;
                                                total2 = total2 + Math.round((coste[1]['Año ' + anio][row[0]][celdaCohorte]['TOTAL'] + Number.EPSILON) * 100) / 100;
                                            } else {
                                                totalesAux['Año ' + anio][coste[0]][row[0]][celda] = verMas == 1 ? Math.round((coste[1]['Año ' + anio][row[0]][celdaCohorte]['TOTAL'] + Number.EPSILON) * 100) / 100 : 0;
                                                total2 = total2 + (verMas == 1 ? Math.round((coste[1]['Año ' + anio][row[0]][celdaCohorte]['TOTAL'] + Number.EPSILON) * 100) / 100 : 0);
                                            }
                                        } else {
                                            totalesAux['Año ' + anio][coste[0]][row[0]][celda] = total2;
                                        }
                                    }
                                })
                            } else {
                                totalesAux['Año ' + anio][coste[0]][row[0]]["TOTAL"] = total2 - total1;
                            }
                    }
                })
            })
        })
        await localforage.setItem('resultados', totalesAux);
    }
}